module.exports = "\r\n<div class=\"w3-display-container\">\r\n\t<div class=\"w3-display-middle\">\r\n\t\t<h6 class=\"w3-text-gray font-6\">\r\n\t\t\t<b>404.</b>\r\n\t\t</h6>\r\n\t\t<p class=\"w3-right\">The page you are trying to visit does not exist</p>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/errors/not-available/not-available.component.html
// module id = ./src/app/components/errors/not-available/not-available.component.html
// module chunks = main